<template>
  <div class="row product-import-list">
    <div class="col-md-12">
      <div class="settings-top-bar sticky-header">
        <div class="top-bar">
          <p>
            <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="goBack">
              <i class="ti-arrow-left"></i>
              {{ $t('general.back') }}
            </a>
          </p>
        </div>
      </div>

      <div class="card mar-to-15">
        <div class="card-content">
          <h5>{{ $t('productImport.importHistory') }}</h5>
          <hr class="sm">
          <div :class="loading ? 'show-loader' : 'hide-loader'">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg>
            </div>
          </div>
          <div class="product-import-table data-table mar-bt-20">
            <el-table :data="batches" style="width:100%" @row-click="openBatch">
              <el-table-column prop="id" :label="$t('productImport.batch')" width="90" align="left" header-align="left">
                <template slot-scope="scope">#{{ scope.row.id }}</template>
              </el-table-column>
              <el-table-column prop="created_at" :label="$t('productImport.date')" width="180" align="left" header-align="left"/>
              <el-table-column prop="original_filename" :label="$t('productImport.file')" min-width="220" align="left" header-align="left" show-overflow-tooltip/>
              <el-table-column :label="$t('productImport.selectPriceProfile')" width="160" align="left" header-align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ (scope.row.price_profile && scope.row.price_profile.name) || (scope.row.price_profiles_id ? ('#' + scope.row.price_profiles_id) : '-') }}
                </template>
              </el-table-column>
              <el-table-column prop="total_rows" :label="$t('productImport.products')" width="100" align="left" header-align="left"/>
              <el-table-column prop="status" :label="$t('productImport.status')" width="160" align="left" header-align="left">
                <template slot-scope="scope">
                  <span>{{ statusLabel(scope.row.status) }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('general.actions')" width="120" align="left" header-align="left">
                <template slot-scope="scope">
                  <el-dropdown trigger="click" placement="bottom-end" @click.native.stop>
                    <span class="arrow-box">&#9662;</span>
                    <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                      <el-dropdown-item @click.native.stop="openBatch(scope.row)">
                        {{ $t('productImport.review') }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'

export default {
  name: 'ProductImportList',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem
  },
  props: {
    route: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      batches: [],
      locationId: null,
      companyId: null
    }
  },
  created () {
    const params = (this.route && this.route.params) || this.$route.params
    this.locationId = params.locationId
    this.companyId = this.$session.get('selectedCompany')
    this.loadBatches()
  },
  methods: {
    statusLabel (status) {
      const map = {
        PENDING: this.$t('productImport.statusPending'),
        CONFIRMED: this.$t('productImport.statusSuccessful'),
        PARTIALLY_CONFIRMED: this.$t('productImport.statusPartiallySuccessful'),
        CANCELED: this.$t('productImport.statusCanceled')
      }
      return map[status] || status
    },
    loadBatches () {
      this.loading = true
      this.apiRequest('/product-imports', 'GET', {
        token: this.$session.get('token'),
        company_id: this.companyId,
        location_id: this.locationId
      }, (response) => {
        this.loading = false
        if (response && response.status) {
          const payload = response.data
          this.batches = (payload && payload.data) ? payload.data : (Array.isArray(payload) ? payload : [])
        }
      })
    },
    openBatch (row) {
      this.$router.push({
        path: `/locations/${this.locationId}/product-imports/${row.id}`
      })
    },
    goBack () {
      this.$router.push('/locations/edit/' + this.locationId)
    }
  }
}
</script>

<style scoped>
/* Flat table like Donation Campaigns / Integration Manager */
.product-import-list .data-table >>> .el-table {
  background-color: #fff;
}

.product-import-list .data-table >>> .el-table .el-table__body-wrapper {
  background-color: #fff;
}

.product-import-list .data-table >>> .el-table thead tr {
  background-color: #E4E8F9 !important;
  clip-path: none;
}

.product-import-list .data-table >>> .el-table thead th {
  background-color: #E4E8F9 !important;
  border-bottom: none !important;
  padding: 8px 0 !important;
}

.product-import-list .data-table >>> .el-table thead th:first-child {
  border-top-left-radius: 11px;
  border-bottom-left-radius: 11px;
}

.product-import-list .data-table >>> .el-table thead th:last-child {
  border-top-right-radius: 11px;
  border-bottom-right-radius: 11px;
}

.product-import-list .data-table >>> .el-table thead th > .cell {
  background: transparent !important;
  height: auto !important;
  min-height: 32px;
  line-height: 1.3;
  padding-left: 14px;
  padding-right: 14px;
}

.product-import-list .data-table >>> .el-table tbody tr.el-table__row {
  background-color: #fff !important;
  clip-path: none;
}

.product-import-list .data-table >>> .el-table tbody tr.el-table__row > td {
  background-color: #fff !important;
  border-bottom: 1px solid #E6EFFB !important;
  padding: 6px 0 !important;
  height: 55px;
}

.product-import-list .data-table >>> .el-table tbody tr.el-table__row:last-child > td {
  border-bottom: none !important;
}

.product-import-list .data-table >>> .el-table tbody tr.el-table__row > td > .cell {
  width: 100%;
  box-sizing: border-box;
  background: transparent !important;
  border-radius: 0 !important;
  height: auto !important;
  min-height: 36px;
  display: flex;
  align-items: center;
  line-height: 1.3;
  padding: 4px 14px;
}

.product-import-list .data-table >>> .el-table tbody tr.el-table__row:hover > td {
  background-color: #E4E8F9 !important;
}

.product-import-list .data-table >>> .el-table tbody tr.el-table__row:hover > td > .cell {
  background: transparent !important;
}

.arrow-box {
  display: inline-block;
  font-size: 18px;
  padding: 4px 6px;
  border: 1px solid #674BD2 !important;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  user-select: none;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
  color: #674BD2;
}
.arrow-box:hover {
  background-color: #674BD2 !important;
  border-color: #674BD2 !important;
  color: #fff !important;
}
.custom-dropdown-menu {
  min-width: 180px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Locations/ProductImports/ProductImportList.vue